/** UTC 기준 포맷 (SSR/클라이언트 동일 결과로 하이드레이션 일치) */
export const formatDateTime = (date: string) => {
  const d = new Date(date)
  const year = d.getUTCFullYear().toString().slice(-2)
  const month = String(d.getUTCMonth() + 1).padStart(2, "0")
  const day = String(d.getUTCDate()).padStart(2, "0")
  const hours = String(d.getUTCHours()).padStart(2, "0")
  const minutes = String(d.getUTCMinutes()).padStart(2, "0")
  return `${year}.${month}.${day} ${hours}:${minutes}`
}

/** UTC 기준 포맷 (SSR/클라이언트 동일 결과로 하이드레이션 일치) */
export const formatDate = (date: string) => {
  const d = new Date(date)
  const year = d.getUTCFullYear().toString().slice(-2)
  const month = String(d.getUTCMonth() + 1).padStart(2, "0")
  const day = String(d.getUTCDate()).padStart(2, "0")
  return `${year}.${month}.${day}`
}

/**
 * `<time datetime>` 속성용 UTC 날짜(YYYY-MM-DD).
 * formatDate와 같은 Date·같은 UTC 접근자에서 뽑으므로 화면 표시 날짜와 어긋날 수 없다.
 * 파싱할 수 없는 값이면 null — 호출부는 속성 없이 기존 렌더를 유지한다.
 */
export const formatDateAttribute = (date: string): string | null => {
  const d = new Date(date)
  if (Number.isNaN(d.getTime())) return null
  const year = String(d.getUTCFullYear()).padStart(4, "0")
  const month = String(d.getUTCMonth() + 1).padStart(2, "0")
  const day = String(d.getUTCDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

const removeEmojis = (payload: string) => {
  return payload
    .replace(/\p{Extended_Pictographic}/gu, "")
    .replace(/\uFE0F/g, "")
    .replace(/\u200D/g, "")
    .trim()
}

export const maskAuthor = (author: string) => {
  const maskEmojiAuthor = removeEmojis(author)
  if (!maskEmojiAuthor) return "Unknown User"
  const firstChar = maskEmojiAuthor[0]
  const rest = "*".repeat(maskEmojiAuthor.length - 1)
  return firstChar + rest
}